import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { storeToken } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (data?.session_token) {
          try { localStorage.setItem("session_token", data.session_token); } catch (_) {}
        }
        setUser(data.user);
        // Clean hash
        window.history.replaceState(null, "", "/");
        if (!data.user.onboarded) {
          navigate("/onboarding", { replace: true, state: { user: data.user } });
        } else {
          navigate("/home", { replace: true, state: { user: data.user } });
        }
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#09090B] flex flex-col items-center justify-center text-foreground">
      <div className="h-12 w-12 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      <div className="mt-4 text-sm text-muted-foreground">Memasukkan kamu...</div>
    </div>
  );
}
